function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  query GetUserQuery($id: String!) {\n    getUserQuery(id: $id) {\n      _id\n      email\n      phone\n      createdAt\n      fullName\n      firstName\n      lastName\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  query FilteredUsers($usersFilter: usersFilterInput!) {\n    filteredUsers(filter: $usersFilter) {\n      _id\n      email\n      type\n      fullName\n      phone\n      permissions {\n        orders\n        menu\n        customers\n        promote\n        analytics\n        settings\n        users\n        allLocations\n        dispensaryIds\n        driver\n        enterpriseAdmin\n        menuReview\n        superMenuReview\n        messaging\n        billing\n      }\n      dispensaryId\n      chainID\n      createdAt\n      createdBy\n      roleAtDispensary\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  query ExportDispensaryUsers($usersFilter: usersFilterInput!) {\n    exportDispensaryUsers(filter: $usersFilter) {\n      csv\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  query UserExistsCheck($input: userIdExistsInput!) {\n    userExistsCheck(input: $input) {\n      exists\n      _id\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  query ValidatePasswordResetTokenQuery($token: String!) {\n    validatePasswordResetTokenQuery(token: $token) {\n      isValid\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  query ValidatePasswordTokenQuery($token: String!) {\n    validatePasswordTokenQuery(token: $token) {\n      isValid\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  query SuperAdminCustomers(\n    $customersFilter: superAdminCustomersFilter\n    $customersSort: customersSortInput\n    $customersPagination: customersPaginationInput\n  ) {\n    superAdminCustomers(filter: $customersFilter, sort: $customersSort, pagination: $customersPagination) {\n      meta {\n        totalCount\n      }\n      customers {\n        _id\n        email\n        createdAt\n        ordersTotal\n        numOrders\n        fullName\n        firstName\n        lastName\n        phone\n      }\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
import gql from 'graphql-tag';
export var getUserQuery = gql(_templateObject());
export var filteredUsers = gql(_templateObject1());
export var exportDispensaryUsers = gql(_templateObject2());
export var userExistsCheck = gql(_templateObject3());
export var validatePasswordResetTokenQuery = gql(_templateObject4());
export var validatePasswordTokenQuery = gql(_templateObject5());
export var superAdminCustomers = gql(_templateObject6());
